import store from "./store/store";

function isAdmin() {
  const users = JSON.parse(localStorage.getItem('users'))
  return users && users[3]?.user_type === 'PO Admin'
}

export default function applyMaintenanceGuard(router) {
  router.beforeEach((to, from, next) => {
    const maintenance = store.state.maintenanceMode

    console.log(maintenance);
    console.log('maintenancecheck------------->');

    // 🔴 MAINTENANCE MODE ON
    if (maintenance) {
      console.log('check1--------->');
      console.log(to.name);
      console.log(to.meta.allowDuringMaintenance);

      // allow routes explicitly allowed
      if (to.meta.allowDuringMaintenance) {
        console.log('test1-------->');
        return next()
      }

      // allow admin to access everything
      // if (to.meta.adminOnlyBypass && isAdmin()) {
      //   return next()
      // }

      if (isAdmin()) {
        console.log('test2-------->');
        return next()
      }

      // already on maintenance page
      if (to.name === 'maintenance') {
        console.log('test3-------->');
        return next()
      }

      // block everything else
      // return next({ name: 'maintenance' })
      return next("/maintenance");
    }else {
       console.log('elsecheck1--------->');
      console.log(to.name);
       // already on maintenance page
      if (to.name === 'Maintenance') {
        console.log('test3-------->');
        return next("/dashboard")
      }
    }

    // 🟢 MAINTENANCE OFF
    if (!maintenance && to.name === 'maintenance') {
      console.log('check2------------->');
      // return next({ name: 'home' }) // or login
      return next("/authentication/login");
    }

    next()
  })
}



// import store from "./store/store";

// function isAdmin() {
//   const users = JSON.parse(localStorage.getItem('users'))
//   return users && users[3]?.user_type === 'Super Admin'
// }

// export default function applyMaintenanceGuard(router) {
//   // 👇 THIS IS beforeEach
//   router.beforeEach((to, from, next) => {
//     const maintenance = store.state.maintenanceMode;

//     console.log(maintenance);
//     console.log('maintenancecheck------------->');

//     if (maintenance) {
//       console.log('check1--------->');
//       console.log(to.name);
//       console.log(to.meta.allowDuringMaintenance);
//       if (to.name === 'maintenance' || to.meta.allowDuringMaintenance) {
//         console.log('test1--------->');
//         return next()
//         // return next("/authentication/login");
//       } else {
//         console.log('test2--------->');
//         // return next({ name: 'maintenance' })
//         return next("/maintenance");
//       }
//     } else {
//       console.log('check2--------->');
//       if (to.name === 'maintenance') {
//         console.log('test3--------->');
//         // return next({ name: 'home' })
//         return next("/authentication/login");
//       }
//     }

//     next()
//   })
// }
